import React from 'react'
import TechSignupComponent from '../components/TechSignup'

function TechSignup() {
  return (
    <div>
      <TechSignupComponent />
    </div>
  )
}

export default TechSignup